import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CardStyle, DocActionButton, PositionIcon, Size } from '../../../base/src/abcCard/abcCard';

enum TemplateEnum {
  Large,
  Medium,
  Small,
}

@Component({
  selector: '',
  template: `
    <mat-card
      [dir]="rtlEnabled"
      [class]="class"
      #matCard
      [id]="id"
      (click)="this.onCardClick.emit()"
      (dblclick)="this.onCardDblClick.emit()"
      [class.subDivContentCardList]="colorBar"
      [attr.style]="'border-left-color:' + colorBar + '!important; height:' + height + 'px !important'"
    >
      <mat-card-header class="matCardHeader" fxLayout="row" fxFlex>
        <div fxLayout="column" fxLayoutAlign="start" fxFlex fxLayoutGap="0px" class="header">
          <mat-card-title
            *ngIf="displayText"
            class="ellipsisOneLine"
            [id]="cardId"
            (mouseenter)="isEllipsisActive(id)"
            [matTooltipDisabled]="disabledTooltip"
            [matTooltip]="displayText"
            [ngClass]="!secondaryDisplayText ? 'centredTitle' : ''"
          >
            <mat-icon
              fxFlex="32px"
              *ngIf="leftIconPosition === positionIcon.Top"
              class="abcCardMatIcon"
              svgIcon="{{ leftIconPath }}"
            ></mat-icon>
            <span [innerHTML]="displayText | highlightSearch: searchInput"></span>
          </mat-card-title>
          <mat-card-subtitle
            class="ellipsisOneLine"
            [id]="secondaryDisplayText"
            (mouseenter)="isEllipsisActive(secondaryDisplayText)"
            [matTooltipDisabled]="disabledTooltip"
            [matTooltip]="secondaryDisplayText"
          >
            <span> {{ secondaryDisplayText }} </span>
          </mat-card-subtitle>
          <div fxLayout="row" *ngIf="headerDescription" class="description ellipsisOneLine">
            <span>{{ description }}</span>
          </div>
        </div>
        <div
          *ngIf="leftIconPosition === positionIcon.Middle"
          [ngClass]="{ sizeIconLarge: leftIconSize === size.Large, sizeIconSmall: leftIconSize === size.Small }"
          [ngStyle]="{ overflow: leftIsImg ? 'hidden' : 'visible' }"
          mat-card-avatar
          class="cardAvatar"
        >
          <div *ngIf="leftIsImg">
            <img *ngIf="leftIconPath" [src]="leftIconPath" class="rightImg" />
            <mat-icon *ngIf="!leftIconPath" svgIcon="profile-user" class="defaultIcon"></mat-icon>
          </div>
          <mat-icon *ngIf="!leftIsImg" fxFlex class="divIconCard" svgIcon="{{ leftIconPath }}"> </mat-icon>
        </div>

        <button *ngIf="!rightIsImg && rightIconPath" mat-flat-button class="matButtonContact">
          <mat-icon style="background-size: 10px 10px;" class="arrowIcon" svgIcon="{{ rightIconPath }}"></mat-icon>
        </button>
        <div *ngIf="rightIsImg" class="rightIsImg">
          <img *ngIf="rightIconPath" [src]="rightIconPath" class="rightImg" />
          <mat-icon *ngIf="!rightIconPath && !shortHand" svgIcon="profile-user" class="defaultIcon"></mat-icon>
          <div *ngIf="!rightIconPath && shortHand" class="cardFirstLetters">
            {{ shortHand }}
          </div>
        </div>
      </mat-card-header>
      <mat-card-content *ngIf="description && !headerDescription"> {{ description }} </mat-card-content>
      <mat-card-actions *ngIf="primaryActionName || secondaryActionName || buttons">
        <div *ngIf="buttons" class="cardButtonsStyle">
          <button
            mat-icon-button
            *ngFor="let btn of buttons"
            [disabled]="!btn.visible"
            (click)="btn.click(); $event.stopPropagation()"
          >
            <mat-icon *ngIf="btn.visible" [svgIcon]="btn.icon" [id]="btn.id"></mat-icon>
          </button>
        </div>
        <button mat-icon-button *ngIf="primaryActionName">
          <mat-icon
            class="customIconSize"
            [svgIcon]="primaryActionName"
            (click)="primaryActionClick(); $event.stopPropagation()"
          >
          </mat-icon>
        </button>
        <button mat-icon-button *ngIf="secondaryActionName">
          <mat-icon class="customIconSize" [svgIcon]="secondaryActionName" (click)="secondaryActionClick()"> </mat-icon>
        </button>
        <!-- <button mat-icon-button>
          <mat-icon class="customIconSize" [svgIcon]="'moreOptions'"> </mat-icon>
        </button> -->
      </mat-card-actions>
    </mat-card>
  `,
  styleUrls: ['./matCard.component.scss'],
})
export class MatCardComponent implements AfterViewInit {
  @Input() id: any;
  @Input() displayText: string;
  @Input() icon: string;
  @Input() buttons: DocActionButton[];
  @Input() secondaryDisplayText: string;
  @Input() template: number;
  @Input() searchInput: string;
  @Input() height: string | number;
  @Input() width: string;
  @Input() image: string;
  @Input() colorBar: string;
  @Input() leftIconPath: string;
  @Input() rightIconSize: number;
  @Input() leftIconSize: number;
  @Input() leftIconPosition: number;
  @Input() rightIconPath: string;
  @Input() rightIsImg: boolean;
  @Input() leftIsImg: boolean;
  @Input() disabledTooltip: boolean = false;
  @Input() description: string;
  @Input() shortHand: string;
  @Input() primaryActionName;
  @Input() secondaryActionName;
  @Input() rtlEnabled: string;
  @Input() headerDescription: boolean;
  @Input() class: string;
  @ViewChild('matCard', { static: true, read: ElementRef }) matCard;
  @Output() onCardClick = new EventEmitter();
  @Output() onCardDblClick = new EventEmitter();
  @Output() onPrimaryActionClick = new EventEmitter();
  @Output() onSecondaryActionClick = new EventEmitter();
  public templateLarge: TemplateEnum = TemplateEnum.Large;
  public templateSmall: TemplateEnum = TemplateEnum.Small;
  public size = Size;
  public positionIcon = PositionIcon;
  public cardId: string;
  public errorImg: boolean = true;
  constructor(private renderer2: Renderer2, private sanitizer: DomSanitizer) {
    this.headerDescription = true;
  }

  ngOnInit() {
    this.leftIconPosition = Number(this.leftIconPosition);
    this.leftIconSize = Number(this.leftIconSize);
    if (this.displayText) this.cardId = this.displayText.toString().replace(/\s/g, '');
  }

  ngAfterViewInit() {
    if (this.class) {
      const element = this.matCard.nativeElement;
      this.renderer2.addClass(element, this.class);
    }
  }

  public isEllipsisActive(id): void {
    const e = document.getElementById(id);
    this.disabledTooltip = e.clientWidth >= e.scrollWidth;
  }

  public setCardStyle(style: CardStyle): void {
    this.height = style.height;
    const element = this.matCard.nativeElement;
    if (style) {
      for (const key in style) {
        element.style[key] = style[key];
      }
    }
  }

  public primaryActionClick(): void {
    this.onPrimaryActionClick.emit();
  }

  public secondaryActionClick(): void {
    this.onSecondaryActionClick.emit();
  }
}
